module.exports = __webpack_public_path__ + "static/ec-chart-desktop-4c4f7695b926050d5480d2844619bcf0.png";